// Utility to handle scrolling to hash anchors with offset for fixed header
export const scrollToHash = (
    hash: string, 
    behavior: ScrollBehavior = 'smooth',
    offset: number = 100 // Default offset for fixed header
) => {
    if (!hash) return;
    
    // Remove the # if present
    const id = hash.replace('#', '');
    const element = document.getElementById(id);
    
    if (element) {
        // Get element position
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        
        // Scroll to position with offset
        window.scrollTo({
            top: offsetPosition,
            behavior: behavior
        });
    }
};

// Scroll to hash with a delay (useful after page transitions)
export const scrollToHashDelayed = (
    hash: string, 
    delay: number = 100,
    offset: number = 100
) => {
    setTimeout(() => {
        scrollToHash(hash, 'smooth', offset);
    }, delay);
};

